function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest(); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var CRLFCRLF = '\r\n\r\n';
/*
 * Shim for 'Object.fromEntries'
 */

function itemsToObject(items) {
  if (typeof Object.fromEntries !== 'undefined') {
    return Object.fromEntries(items);
  }

  var obj = {};

  var _iterator = _createForOfIteratorHelper(items),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _ref3 = _step.value;

      var _ref2 = _slicedToArray(_ref3, 2);

      var key = _ref2[0];
      var value = _ref2[1];
      obj[key.toLowerCase()] = value;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return obj;
}
/**
 * Parse HTTP headers from a given string.
 * @param {String} text the text to parse the headers from
 * @returns {Object} the parsed headers with lowercase keys
 */


function parseHeaders(text) {
  var items = text.split('\r\n').map(function (line) {
    var kv = line.split(':').map(function (str) {
      return str.trim();
    });
    kv[0] = kv[0].toLowerCase();
    return kv;
  });
  return itemsToObject(items);
}
/**
 * Parse a 'Content-Type' header value to the content-type and parameters
 * @param {String} rawContentType the raw string to parse from
 * @returns {Object} the parsed content type with the fields: type and params
 */


export function parseContentType(rawContentType) {
  var _rawContentType$split = rawContentType.split(';').map(function (s) {
    return s.trim();
  }),
      _rawContentType$split2 = _toArray(_rawContentType$split),
      type = _rawContentType$split2[0],
      rawParams = _rawContentType$split2.slice(1);

  var paramsItems = rawParams.map(function (param) {
    return param.split('=');
  });
  return {
    type: type,
    params: itemsToObject(paramsItems)
  };
}
/**
 * Parse a 'Content-Range' header value to its start, end, and total parts
 * @param {String} rawContentRange the raw string to parse from
 * @returns {Object} the parsed parts
 */

export function parseContentRange(rawContentRange) {
  var start;
  var end;
  var total;

  if (rawContentRange) {
    var _rawContentRange$matc = rawContentRange.match(/bytes (\d+)-(\d+)\/(\d+)/);

    var _rawContentRange$matc2 = _slicedToArray(_rawContentRange$matc, 4);

    start = _rawContentRange$matc2[1];
    end = _rawContentRange$matc2[2];
    total = _rawContentRange$matc2[3];
    start = parseInt(start, 10);
    end = parseInt(end, 10);
    total = parseInt(total, 10);
  }

  return {
    start: start,
    end: end,
    total: total
  };
}
/**
 * Parses a list of byteranges from the given 'multipart/byteranges' HTTP response.
 * Each item in the list has the following properties:
 * - headers: the HTTP headers
 * - data: the sliced ArrayBuffer for that specific part
 * - offset: the offset of the byterange within its originating file
 * - length: the length of the byterange
 * @param {ArrayBuffer} responseArrayBuffer the response to be parsed and split
 * @param {String} boundary the boundary string used to split the sections
 * @returns {Object[]} the parsed byteranges
 */

export function parseByteRanges(responseArrayBuffer, boundary) {
  var offset = null;
  var decoder = new TextDecoder('ascii');
  var out = [];
  var startBoundary = "--".concat(boundary);
  var endBoundary = "".concat(startBoundary, "--"); // search for the initial boundary, may be offset by some bytes
  // TODO: more efficient to check for `--` in bytes directly

  for (var i = 0; i < 10; ++i) {
    var text = decoder.decode(new Uint8Array(responseArrayBuffer, i, startBoundary.length));

    if (text === startBoundary) {
      offset = i;
    }
  }

  if (offset === null) {
    throw new Error('Could not find initial boundary');
  }

  while (offset < responseArrayBuffer.byteLength) {
    var _text = decoder.decode(new Uint8Array(responseArrayBuffer, offset, Math.min(startBoundary.length + 1024, responseArrayBuffer.byteLength - offset))); // break if we arrived at the end


    if (_text.length === 0 || _text.startsWith(endBoundary)) {
      break;
    } // assert that we are actually dealing with a byterange and are at the correct offset


    if (!_text.startsWith(startBoundary)) {
      throw new Error('Part does not start with boundary');
    } // get a substring from where we read the headers


    var innerText = _text.substr(startBoundary.length + 2);

    if (innerText.length === 0) {
      break;
    } // find the double linebreak that denotes the end of the headers


    var endOfHeaders = innerText.indexOf(CRLFCRLF); // parse the headers to get the content range size

    var headers = parseHeaders(innerText.substr(0, endOfHeaders));

    var _parseContentRange = parseContentRange(headers['content-range']),
        start = _parseContentRange.start,
        end = _parseContentRange.end,
        total = _parseContentRange.total; // calculate the length of the slice and the next offset


    var startOfData = offset + startBoundary.length + endOfHeaders + CRLFCRLF.length;
    var length = parseInt(end, 10) + 1 - parseInt(start, 10);
    out.push({
      headers: headers,
      data: responseArrayBuffer.slice(startOfData, startOfData + length),
      offset: start,
      length: length,
      fileSize: total
    });
    offset = startOfData + length + 4;
  }

  return out;
}